<template>
    <v-alert outline
             :value="true"
             color="success"
             icon="new_releases"
             class="special_price_alert pa-2 ma-0 notranslate"
    >
        <div class="special_price_alert_container">
            <span>{{ offersBasicPlan
                ? $t('Limited time pro special offer')
                : $t('Limited time annuity special offer')
            }}</span>
            <span class="ticket_pricing">
                <span class="discount">
                    {{ formatMoney(regularPrice - info['payment_info']['amount']) }}
                    {{ $t('discount_off') }}
                </span>
                <span class="regular_price">{{ formatMoney(regularPrice) }}</span>
                <span class="price">{{ formatMoney(info['payment_info']['amount']) }}</span>
            </span>
        </div>
    </v-alert>
</template>

<script>
  import { formatMoney } from "../utils/functions";
  import { annuityRegularPrice } from "../utils/rules";

  export default {
    name: "SpecialOfferAlert",
    props: {
      info: {
        type: Object,
        required: true
      }
    },
    computed: {
      regularPrice: function() {
        return this.info.country.iso === 'br'
          ? annuityRegularPrice['br']
          : annuityRegularPrice['ex']
      },
      offersBasicPlan: function () {
            return this.$store.state.segments
              .find(el => el.data.id === this.info.id).offers_basic_plan
      }
    },
    methods: {
      formatMoney: function (amount) {
        const currency = (this.info.country.iso === 'br') ? 'R$' : 'U$'
        return formatMoney(currency, amount)
      }
    },
  }
</script>

<style scoped lang="scss">
    .special_price_alert {
        .special_price_alert_container {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
        }
        div {
            color: rgba(0,0,0,0.87);
        }
        .ticket_pricing * {
            line-height: 24px;
            display: inline-block;
        }
        .ticket_pricing .discount {
            font-size: 14px;
            color: var(--error-color);
            font-weight: bold;
        }
        .ticket_pricing .regular_price {
            font-size: 16px;
            color: rgba(0,0,0,0.38);
            position: relative;
            margin-left: 12px;
            font-family: 'Roboto Mono', monospace;
            font-weight: 700;
        }
        .ticket_pricing .regular_price::before {
            content: '';
            position: absolute;
            top: 11px;
            height: 2px;
            left: -2px;
            right: -2px;
            background: rgba(0,0,0,0.87);
            transform: rotate(-5deg);
        }
        .ticket_pricing .price {
            font-size: 18px;
            color: rgba(0,0,0,0.87);
            margin-left: 12px;
            font-family: 'Roboto Mono', monospace;
            font-weight: 700;
        }
        .ticket_pricing .regular_price + .price {
            color: var(--success-color);
        }
    }
</style>

<i18n>
    {
        "en": {
            "Limited time annuity special offer": "Limited time annuity special offer",
            "Limited time pro special offer": "Limited time Pro plan annuity special offer",
            "discount_off": "off"
        },
        "pt": {
            "Limited time annuity special offer": "Oferta na anuidade por tempo limitado",
            "Limited time pro special offer": "Oferta na anuidade do plano Pro por tempo limitado",
            "discount_off": "de desconto"
        }
    }
</i18n>
